export default __webpack_public_path__ + "static/media/room.6b7a89d0.webp";